import React, { useState, useEffect } from "react";
// STYLES
import * as Style from "./PreviousDiscountsStyle";

// LIBRARIES

// MISC
import { IDiscount } from "./PreviousDiscountsModel";
import { discountCardsList } from "mocks/PreviousDiscountsMock";
import { COLORS } from "constants/styleVariables";
import { ButtonTypes } from "models/GeneralTypes/generalTypes";

// ASSETS

// REDUX

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import InputAtom from "components/Atoms/InputAtom/InputAtom";
import DiscountCard from "components/DiscountCard/DiscountCard";
import Pagination from "components/TablePagination/TablePagination";

const PreviousDiscounts = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES

  // CONSTANTS USING HOOKS
  const [inputValue, setInputValue] = useState<string>("");
  const [discountsList, setDiscountsList] = useState<IDiscount[]>(discountCardsList);
  const [currentPage, setCurrentPage] = useState<number>(0);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    if (inputValue.length > 0) {
      let filteredDiscounts = discountCardsList.filter((discount) =>
        discount.discountText.toLowerCase().includes(inputValue.toLowerCase())
      );
      setDiscountsList(filteredDiscounts);
    } else {
      setDiscountsList(discountCardsList);
    }
  }, [inputValue]);
  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleClearFilters = () => {
    setInputValue("");
    setDiscountsList(discountCardsList);
  };

  return (
    <Style.PreviousDiscountsContainer>
      <Style.Title>Istoric Discount-uri</Style.Title>
      <Style.SearchContainer>
        <Style.InputAtomContainer>
          <InputAtom
            placeholder="Cauta..."
            label="Cauta"
            inputValue={inputValue}
            setInputValue={setInputValue}
          />
        </Style.InputAtomContainer>
        <Style.ButtonAtomContainer>
          <ButtonAtom
            text="Clear filters"
            onClick={handleClearFilters}
            type={ButtonTypes.MAIN_BUTTON}
          />
        </Style.ButtonAtomContainer>
      </Style.SearchContainer>
      <Style.DiscountsContainer>
        {discountsList.map((discountDetails, index) => (
          <DiscountCard
            discountDetails={discountDetails}
            key={index}
            opacity="0.2"
            background={COLORS.forthBlack}
          />
        ))}
      </Style.DiscountsContainer>
      <Style.PaginationContainer>
        <Pagination
          onChange={(e, newPage) => setCurrentPage(newPage - 1)}
          currentPage={currentPage}
          totalPage={Math.ceil(discountCardsList.length / 8)}
        />
      </Style.PaginationContainer>
    </Style.PreviousDiscountsContainer>
  );
};

export default PreviousDiscounts;
